module.exports = __webpack_public_path__ + "img/bill-cancel.4df4731b.png";